import { render, staticRenderFns } from "./SupportWhatsappBubble.vue?vue&type=template&id=29a5575f&"
import script from "./SupportWhatsappBubble.vue?vue&type=script&lang=js&"
export * from "./SupportWhatsappBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports